module.exports = __webpack_public_path__ + "static/quadpay-chrome-c7eb15876f33a1ea00e19f87336e7cfd.mp4";